import { IFontData } from "./font-data";
import { INavigationData, INavigationLinkData, NavigationMenuType } from "./header-data";
import { SelfPosition, Orientation, IWidgetVisibility, WidgetPlaceType, LinkData, IInteractiveElementColorData, IBorderRadiusData } from "./index";
import { IAnimatedWidget } from "./widget-style-data";
import { TranslateService } from "../services/translate.service";

export interface IMenuWidgetData extends INavigationData, IWidgetVisibility {
    readonly type: "MenuWidget",
    placeType: WidgetPlaceType;
    id?: string | null;
    layoutType?: MenuLayoutType;
    style: IAnimatedWidget;
    menuStyle?: IMenuStyleData | null;
    submenuStyle?: ISubmenuStyleData | null;
}

export type MenuLayoutType = "wrap" | "more";

export interface IMenuStyleData {
    itemsLayoutType?: MenuItemsLayoutType;
    itemsLayoutTypeStyle?: IMenuItemsLayoutStyle;
    space?: number | null;
    spaceBetweenRows?: number | null;
    alignment?: SelfPosition | null;
    orientation: Orientation;
    font?: IFontData | null;
    linkColorStyleData?: IInteractiveElementColorData | null;
}

export interface ISubmenuStyleData {
    backgroundColor?: string | null;
    linkColorStyleData?: IInteractiveElementColorData | null;
}

export enum MenuWidgetType {
    Automatic = "Automatic",
    Custom = "Custom"
}

export type MenuItemsLayoutType = "default" | "divided" | "overlined" | "button";

export abstract class MenuWidgetData {

    public static get defaultData(): IMenuWidgetData {
        return {
            type: "MenuWidget",
            placeType: "Section",
            layoutType: "wrap",
            links: [],
            menuStyle: this.defaultMenuStyle,
            submenuStyle: this.defaultSubmenuStyle,
            menuType: NavigationMenuType.Automatic,
            visibility: {
                desktop: true,
                tablet: true,
                mobile: false
            },
            style: {
                animation: {
                    animationSource: "site-design",
                    animationData: {
                        name: "none",
                        duration: 1
                    }
                }
            }
        };
    }

    public static get defaultStyle(): IAnimatedWidget {
        return {
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static get defaultMenuStyle(): IMenuStyleData {
        return {
            space: 20,
            spaceBetweenRows: 20,
            alignment: "start",
            itemsLayoutType: "default",
            itemsLayoutTypeStyle: {},
            orientation: Orientation.Horizontal,
            font: {
                weight: "",
                family: "",
                size: "",
                lineHeight: ""
            },
            linkColorStyleData: {
                colorDefault: "#202020",
                colorHovered: "#DBDBDB",
                colorClicked: "#12A3F8"
            }
        };
    }

    public static get defaultSubmenuStyle(): ISubmenuStyleData {
        return {
            backgroundColor: "#ffffff",
            linkColorStyleData: {
                colorDefault: "#202020",
                colorHovered: "#DBDBDB",
                colorClicked: "#12A3F8"
            }
        };
    }

    public static get defaultButtonStyle(): IMenuItemsButtonStyle {
        return {
            colors: {
                colorDefault: "#DBDBDB",
                colorHovered: "#12A3F8",
                colorClicked: "#202020"
            },
            radius: {
                topLeftPx: 0,
                topRightPx: 0,
                bottomLeftPx: 0,
                bottomRightPx: 0
            }
        };
    }

    public static defaultMoreLinkData(lang: string): INavigationLinkData {
        return {
            id: "more-link",
            text: TranslateService.translator(lang).MENU_WIDGET.DEFAULT_MORE_LINK_TEXT,
            value: LinkData.noneData
        };
    }

}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IMenuItemsBaseStyle {
}

export type IMenuItemsDefaultStyle = IMenuItemsBaseStyle;
export type IMenuItemsDividedStyle = IMenuItemsBaseStyle;
export type IMenuItemsOverlinedStyle = IMenuItemsBaseStyle;

export interface IMenuItemsButtonStyle extends IMenuItemsBaseStyle {
    colors?: IInteractiveElementColorData;
    radius?: IBorderRadiusData;
}

export type IMenuItemsLayoutStyle = IMenuItemsDefaultStyle | IMenuItemsDividedStyle | IMenuItemsOverlinedStyle | IMenuItemsButtonStyle;
